<template>
  <div class="z-card">
    {{ $t('mailer.not_sender.not_sender') }}
    <br />
    {{ $t('mailer.not_sender.to_create') }}
    <router-link :to="{ name: 'mailer.sender.index' }">
      {{ $t('mailer.not_sender.link') }}
    </router-link>
    {{ $t('mailer.not_sender.and_to_create') }}
  </div>
</template>

<script>
  export default {};
</script>
